var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-actions', {
    attrs: {
      "action-collapse": "",
      "title": "Pengaturan Sub Menu "
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2",
      "sm": "4"
    }
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.addMenu($event);
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Tambah ")], 1), _c('b-modal', {
    attrs: {
      "id": "modal-tambah",
      "cancel-variant": "secondary",
      "ok-title": "Submit",
      "cancel-title": "Batal",
      "title": "Form Role Management",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "size": "lg"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('section', {
          staticClass: "d-flex justify-content-end align-items-center mb-2"
        }, [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.submit
          }
        }, [_vm._v(" Simpan ")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('b-form', [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', [_c('label', {
    attrs: {
      "for": "level_id"
    }
  }, [_c('strong', [_vm._v("Level")])]), _c('b-form-select', {
    attrs: {
      "options": _vm.levels,
      "label": "Level"
    },
    model: {
      value: _vm.form.level_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "level_id", $$v);
      },
      expression: "form.level_id"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', [_c('label', {
    attrs: {
      "for": "menu_id"
    }
  }, [_c('strong', [_vm._v("Menu")])]), _c('b-form-select', {
    attrs: {
      "options": _vm.menus,
      "label": "Menu"
    },
    model: {
      value: _vm.form.menu_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "menu_id", $$v);
      },
      expression: "form.menu_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_c('strong', [_vm._v(" Pengaturan Menu ")])])])], 1), _c('b-form-group', [_c('label', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Status di menu (opsional)")])]), _c('v-select', {
    attrs: {
      "options": _vm.statusOptions,
      "multiple": "",
      "label": "text"
    },
    model: {
      value: _vm.selectedStatus,
      callback: function callback($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  })], 1), _vm.isParentMenu ? _c('b-form-group', [_c('label', {
    attrs: {
      "for": "sub_menu"
    }
  }, [_vm._v("Sub Menu")]), _c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.sub_menus,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text"
    },
    model: {
      value: _vm.selectedSubMenus,
      callback: function callback($$v) {
        _vm.selectedSubMenus = $$v;
      },
      expression: "selectedSubMenus"
    }
  })], 1) : _vm._e(), _c('br'), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Jenis Akses")])]), _c('section', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.create,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "create", $$v);
      },
      expression: "form.create"
    }
  }, [_vm._v(" Tambah ")])], 1), _c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.update,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "update", $$v);
      },
      expression: "form.update"
    }
  }, [_vm._v(" Ubah ")])], 1), _c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.delete,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "delete", $$v);
      },
      expression: "form.delete"
    }
  }, [_vm._v(" Hapus ")])], 1)], 1)]), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Peruntukan Akses")])]), _c('section', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.web,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "web", $$v);
      },
      expression: "form.web"
    }
  }, [_vm._v(" Aplikasi Web ")])], 1), _c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.mobile,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mobile", $$v);
      },
      expression: "form.mobile"
    }
  }, [_vm._v(" Aplikasi Mobile ")])], 1)], 1)]), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_c('strong', [_vm._v("Kode Notifikasi Per Level")]), _vm._v(" "), _c('feather-icon', {
    attrs: {
      "icon": "InfoIcon"
    }
  })], 1), _c('v-select', {
    attrs: {
      "options": _vm.notif_params,
      "label": "text",
      "reduce": function reduce(option) {
        return option.value;
      }
    },
    model: {
      value: _vm.form.param_notif,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "param_notif", $$v);
      },
      expression: "form.param_notif"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_c('strong', [_vm._v("Data Logged User Only (Khusus Aplikasi Mobile)")])]), _c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.filter,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "filter", $$v);
      },
      expression: "form.filter"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "sm": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0"
  }, [_c('label', {
    staticClass: "d-inline-block text-sm-left mr-50"
  }, [_vm._v("Per page")]), _c('b-form-select', {
    staticClass: "w-50",
    attrs: {
      "id": "perPageSelect",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Filter",
      "label-cols-sm": "3",
      "label-align-sm": "right",
      "label-size": "sm",
      "label-for": "filterInput"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filterInput",
      "type": "search",
      "placeholder": "Type to Search"
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function click($event) {
        _vm.filter = '';
      }
    }
  }, [_vm._v(" Clear ")])], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "responsive": "",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "items": _vm.items,
      "fields": _vm.fields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "filter": _vm.filter,
      "filter-included-fields": _vm.filterOn
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_c('strong', {
          staticClass: "text-center"
        }, [_vm._v(" " + _vm._s(row.index + 1) + " ")])];
      }
    }, {
      key: "cell(level_id)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(" " + _vm._s(_vm.getlevelName(data.item)) + " ")])];
      }
    }, {
      key: "cell(menu_id)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v(" " + _vm._s(_vm.getmenuName(data.item)) + " ")])];
      }
    }, {
      key: "cell(create)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.create ? _c('feather-icon', {
          staticClass: "text-success",
          attrs: {
            "icon": "CheckIcon",
            "size": "24"
          }
        }) : _c('feather-icon', {
          staticClass: "text-danger",
          attrs: {
            "icon": "XIcon",
            "size": "24"
          }
        })];
      }
    }, {
      key: "cell(update)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.update ? _c('feather-icon', {
          staticClass: "text-success",
          attrs: {
            "icon": "CheckIcon",
            "size": "24"
          }
        }) : _c('feather-icon', {
          staticClass: "text-danger",
          attrs: {
            "icon": "XIcon",
            "size": "24"
          }
        })];
      }
    }, {
      key: "cell(delete)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.delete ? _c('feather-icon', {
          staticClass: "text-success",
          attrs: {
            "icon": "CheckIcon",
            "size": "24"
          }
        }) : _c('feather-icon', {
          staticClass: "text-danger",
          attrs: {
            "icon": "XIcon",
            "size": "24"
          }
        })];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(row) {
        return [_c('b-dropdown', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(255, 255, 255, 0.15)',
            expression: "'rgba(255, 255, 255, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "dropdown-icon-wrapper",
          attrs: {
            "id": "dropdown-3",
            "variant": "primary",
            "right": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "align-middle",
                attrs: {
                  "icon": "ListIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [!row.item.sub_menu ? _c('b-dropdown-item', [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Ubah',
            expression: "'Ubah'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        }), _vm._v("Ubah ")], 1)], 1) : _vm._e(), _c('b-dropdown-item', [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Hapus',
            expression: "'Hapus'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        }), _vm._v("Hapus ")], 1)], 1)], 1)];
      }
    }, {
      key: "cell(urutan)",
      fn: function fn(row) {
        return [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Atas',
            expression: "'Atas'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function click($event) {
              return _vm.atas(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "ArrowUpIcon"
          }
        })], 1), _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Bawah',
            expression: "'Bawah'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function click($event) {
              return _vm.bawah(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "ArrowDownIcon"
          }
        })], 1)];
      }
    }, {
      key: "row-details",
      fn: function fn(row) {
        return [_c('b-card', [_c('ul', _vm._l(row.item, function (value, key) {
          return _c('li', {
            key: key
          }, [_vm._v(_vm._s(key) + ": " + _vm._s(value))]);
        }), 0)])];
      }
    }])
  })], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }